<template>
	<div>
		<div class="content-zsy" v-loading="loading" style="min-height: 400px;">
			<div class="column-center" v-if="info">
				<h3>메세지함</h3>
				<div class="content-title" >
					{{info.title}}
				</div>
				<div class="content-date">
					{{info.createtime}} / {{info.nickname}}
				</div>
				<div class="content" v-html="info.content">
				</div>
				<div class="content-bottom">
					<el-button @click="onOneConsultList">글목록</el-button>
				</div>
				
			</div>
			
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	export default {
		props: ['id'],
		data() {
			return {
				info:"",
				loading: true,
			}
		},
		created() {
			this.getDetail()
		},
		methods: {
			getDetail(){
				this.loading = true
				request.post('/member/Message/getMessageDetail',
					{
						id:this.id,
					}
				).then(res => {
					this.loading = false
					console.log(res.data,"xiangqing")
					if(res.code ==1){
						this.info = res.data
					}			
				}).catch(() => {
					this.loading = false
				});
			},
			onOneConsultList(){
				this.$router.push(`/message`)
			}
			
		}
	}
</script>

<style scoped>
	.column-center h3 {
	    text-align: center;
	    font-size: 45px;
	    font-weight: bold;
	    color: var(--frontground-color);
	    padding: 60px 0 0 0;
	    margin: 0 0 60px;
	}
	.content-title{
		font-size: 24px;
		border-top: 2px solid #000;
		text-align: left;
		padding: 13px 15px;
		font-weight: 500;
	
	}
	.content-date{
		padding: 20px 15px;
		color: #6a6a6a;
		border: solid 1px var(--border-color);
		border-width: 1px 0;
	}
	.content{
		padding: 20px 15px;
		border: solid 1px var(--border-color);
		border-width: 0 0 1px 0;
	}
	.content-bottom{
		padding:20px;
		display: flex;
		justify-content: end;
	}

	
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
</style>